import { render } from "./PersonaEditor.vue?vue&type=template&id=a661ede2&scoped=true"
import script from "./PersonaEditor.vue?vue&type=script&lang=js"
export * from "./PersonaEditor.vue?vue&type=script&lang=js"

import "./PersonaEditor.vue?vue&type=style&index=0&id=a661ede2&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a661ede2"]])

export default __exports__